import { useRef, useEffect, useState } from 'react';

export const useOutsideClick = () => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClickOutside = (event) => {
    const selectContainer = document.getElementsByClassName('MuiPopover-root');

    if (
      ref.current &&
      !ref.current.contains(event.target) &&
      !selectContainer.length
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return { ref, isOpen, setIsOpen };
};
